import React, {forwardRef} from "react";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

/**
 *
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef< import('@mui/material').ToggleButtonGroupProps & {
 * readonly options?: import('@mui/material').ToggleButtonProps[]
 * }> & React.RefAttributes<unknown>>}
 */
const ToggleButtons = forwardRef(({
                                      options,
                                      ...props
                                  }, ref) => {

    return (
        <ToggleButtonGroup
            ref={ref}
            {...props}
        >
            {
                options.map((option) => (
                    <ToggleButton
                        key={option.value}
                        value={option.value}
                        aria-label={option.ariaLabel || option['aria-label']}
                        className={`text-sm`}
                        {...option.props}
                    >
                        {option.name}
                    </ToggleButton>
                ))
            }
        </ToggleButtonGroup>
    );
})
export default ToggleButtons;
